module.exports = __webpack_public_path__ + "img/eyecare-logo-colored.3fe070a4.png";